import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { formatNumberWithCommas, getBNMNOrKValueFromMillions } from '../../../utils/utils';



const buShortForms = {
  "Australia": "AUS",
  "Canada": "CA",
  "China": "CHN",
  "Egypt": "EGY",
  "Hong Kong": "HK",
  "India": "IN",
  "Indonesia": "IN",
  "Japan": "JD",
  "Korea": "KR",
  "Malaysia": "MY",
  "New Zealand": "NZ",
  "NORTH AMERICA": "NA",
  "Pakistan": "PAK",
  "Philippines": "PH",
  "SaudiArabia": "KSA",
  "Singapore": "SG",
  "South Africa": "SA",
  "Taiwan": "TW",
  "Thailand": "TH",
  "UAE": "UAE",
  "US": "US",
  "Vietnam": "WN",
  "WECA": "WECA",
  "MULTI BU": "MULTI BU",
  "Completed YTD": "Completed YTD",
  "Balance of the Year": "Balance of the Year",
  "Documented": "Documented",
  "No Action Items": "No Action Items",
  "Completed": "Completed",
}
function getCountryCodeIgnoreCase(inputKey) {
  const foundKey = Object.keys(buShortForms).find(
    key => key?.toLowerCase() === inputKey.toLowerCase()
  );
  return foundKey ? buShortForms[foundKey] : null;
}

const SpendDonutChart = ({ countryData, flag, isSpendChart=false, showInnerChart=true, isTradeAnalyticsPage=false, isCategoryForums=false}) => {
  const categoryData = Object.values(
    countryData.reduce((acc, { category, value }) => {
      acc[category] = acc[category] || { name: category, value: 0 };
      acc[category].value += value;
      return acc;
    }, {})
  );
  const CustomTooltip = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
				{ payload[0]['payload']['category'] && <div>{`${payload[0]['payload']['category']}`}</div> }
				<div style={{ color: payload[0]['payload']['category']?`${payload[0]['payload']['color']}`:`${payload?.[0]?.['payload']['fill']}` }}>
            {`${payload[0]['payload']['name']}`}: 
            {`${
                  isSpendChart?
                        payload[0]['payload']['category']?
                            formatNumberWithCommas((payload[0]['payload']['value']).toFixed(2))
                            :getBNMNOrKValueFromMillions((payload[0]['payload']['value']))
                      //getBNMNOrKValueFromMillions((payload[0]['payload']['value'])):
                      :payload[0]['payload']['value']}`
               }
              {isSpendChart && payload[0]['payload']['category']?"MN":""}
        </div>
			</div>
		);
	}

	return null;
};

    // const CustomLabelWithYTick = ({
    //     name,
    //     value,
    //     percent,
    //     outerRadius,
    //     midAngle,
    //     cx,
    //     cy
    // }) => {
    //     if (percent < 0.05) return null;
    
    //     const RADIAN = Math.PI / 180;
    //     const radius = outerRadius ; // + 5
    //     const labelRadius = outerRadius + 10; // + 20
    
    //     const startX = cx + radius * Math.cos(-midAngle * RADIAN);
    //     const startY = cy + radius * Math.sin(-midAngle * RADIAN);
    
    //     const endX = cx + labelRadius * Math.cos(-midAngle * RADIAN);
    //     const endY = cy + labelRadius * Math.sin(-midAngle * RADIAN);
    
    //     return (
    //     <>
    //         {/* Manual tick line */}
    //         <line
    //         x1={startX}
    //         y1={startY}
    //         x2={endX}
    //         y2={endY}
    //         stroke="#333"
    //         strokeWidth={1}
    //         />
    //         {/* Label text */}
    //         <text
    //         x={endX}
    //         y={endY}
    //         fill="#000"
    //         textAnchor={endX > cx ? 'start' : 'end'}
    //         dominantBaseline="central"
    //         fontSize={12}
    //         >
    //         {`${name}: ${value}`}
    //         </text>
    //     </>
    //     );
    // };

    const CustomLabelWithY2Tick = ({
        name,
        value,
        percent,
        outerRadius,
        midAngle,
        cx,
        cy
      }) => {
        if (percent < 0.04) return null; // percent < 0.05
      
        const RADIAN = Math.PI / 180;
      
        // // Start point: exactly on outer circle edge
        // const startRadius = outerRadius;
        // const startX = cx + startRadius * Math.cos(-midAngle * RADIAN);
        // const startY = cy + startRadius * Math.sin(-midAngle * RADIAN);
      
        // // End point: slightly further outside for label
        // const labelRadius = outerRadius + 25;
        // const endX = cx + labelRadius * Math.cos(-midAngle * RADIAN);
        // const endY = cy + labelRadius * Math.sin(-midAngle * RADIAN);

        const startX = cx + outerRadius * Math.cos(-midAngle * RADIAN);
        const startY = cy + outerRadius * Math.sin(-midAngle * RADIAN);
      
        const labelRadius = outerRadius + 25;
        const baseX = cx + labelRadius * Math.cos(-midAngle * RADIAN);
        const baseY = cy + labelRadius * Math.sin(-midAngle * RADIAN);
      
        // Add extra spacing (6px) based on direction
        const offset = 2;
        const labelX = baseX + (baseX > cx ? offset : -offset);
        const labelY = baseY;

        let categoryDisplayKey = null;
        if(name==="GP INDIRECTS") {
          categoryDisplayKey = "I"
        } else if(name==="GP DIRECTS") {
          categoryDisplayKey = "D"
        }
        else if(name==="CO MAN") {
          categoryDisplayKey = "C"
        } else {
          categoryDisplayKey = getCountryCodeIgnoreCase(name)
        }
      
        return (
          <>
            {/* Tick line that starts from outer circle edge */}
            <line
              x1={startX}
              y1={startY}
            //   x2={endX}
            //   y2={endY}
                x2={baseX}
                y2={baseY}
              stroke="#3a3a3a"
              strokeWidth={0.5}
            />
            {/* Label positioned at the end of the tick */}
            <text
            //   x={endX}
            //   y={endY}
            x={labelX}
            y={labelY}
              fill="#3a3a3a"
            //  textAnchor={endX > cx ? 'start' : 'end'}
            textAnchor={labelX > cx ? 'start' : 'end'}
              dominantBaseline="central"
              fontSize={10}
            >
              {/* {`${name}: ${formatNumberWithCommas(value)}`} */}
              {/* {`${formatNumberWithCommas(value)}`} */}
              {/* {isSpendChart?`${name}- ${getBNMNOrKValueFromMillions(value)} (${(percent * 100).toFixed(0)}%)`:`${formatNumberWithCommas(value)}`} */}
              {/* {isSpendChart?
                `${(categoryDisplayKey?categoryDisplayKey+"-":"") +getBNMNOrKValueFromMillions(value)}(${(percent * 100).toFixed(0)}%)`
                :`${formatNumberWithCommas(value)}`} */}
                {isSpendChart ? (
                    <>
                      {categoryDisplayKey && (
                        <tspan fontWeight="bold" fontSize={11}>{categoryDisplayKey}-</tspan>
                      )}
                      <tspan>{getBNMNOrKValueFromMillions(value)}</tspan>
                      <tspan fontWeight="bold">{`(${(percent * 100).toFixed(0)}%)`}</tspan>
                    </>
                  ) : isTradeAnalyticsPage ? (
                    <>
                      {categoryDisplayKey && (
                        <tspan fontWeight="bold" fontSize={11}>{categoryDisplayKey}-</tspan>
                      )}
                      <tspan>{formatNumberWithCommas(value)}</tspan>
                      <tspan fontWeight="bold">{`(${(percent * 100).toFixed(0)}%)`}</tspan>
                    </>
                  ) :
                  (
                    <>
                      {categoryDisplayKey && (
                        <tspan fontWeight="bold" fontSize={11}>{categoryDisplayKey}-</tspan>
                      )}
                      <tspan fontWeight="bold" {...(isCategoryForums ? { fontSize: 11 } : {})}>{formatNumberWithCommas(value)}</tspan>
                      {/* <tspan fontWeight="bold">{`(${(percent * 100).toFixed(0)}%)`}</tspan> */}
                    </>
                  )}
              
            </text>
          </>
        );
      };
      

    // const CustomLabelWithTick = (props) => {
    //     const {
    //     name,
    //     value,
    //     percent,
    //     x,
    //     y,
    //     outerRadius,
    //     midAngle,
    //     cx,
    //     cy,
    //     index
    //     } = props;
    
    //     // Filter small slices â€” e.g., < 5% of total
    //     if (percent < 0.05) return null;
    
    //     // Tick end position
    //     const RADIAN = Math.PI / 180;
    //     const radius = outerRadius + 10;
    //     const labelX = cx + radius * Math.cos(-midAngle * RADIAN);
    //     const labelY = cy + radius * Math.sin(-midAngle * RADIAN);
    
    //     return (
    //     <text
    //         x={labelX}
    //         y={labelY}
    //         fill="#000"
    //         textAnchor={labelX > cx ? 'start' : 'end'}
    //         dominantBaseline="central"
    //         fontSize={12}
    //     >
    //         {`${name}: ${value}`}
    //     </text>
    //     );
    // }
    const renderCategoryLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name }) => {
      const radius = innerRadius + (outerRadius - innerRadius) / 2;
      const RADIAN = Math.PI / 180;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);
      const textColor = name==="APAC"? "#000": "#fff"
    
      if((percent * 100).toFixed(0)<4) {
        return <text></text>
      } else {
        return (
          <text x={x} y={y} fill={textColor} textAnchor="middle" dominantBaseline="central" fontSize={12} fontWeight={700}>
            {/* {categoryData[index].value} */}
            {(percent * 100).toFixed(0)}%
          </text>
        );
      }
    };
  
  // const CATEGORY_COLORS = [...new Set(countryData.map(item => item.color))];
  // const COUNTRY_COLORS = countryData.map(item => item.color);
  const CATEGORY_COLORS = [...new Set(countryData.map(item => item.sectorColor))];
  const COUNTRY_COLORS = countryData.map(item => item.color);
  return (
    <ResponsiveContainer width="100%" height={350}> {/* 400 */}
      <PieChart margin={{ top: 10, right: 120, bottom: 10, left: 120 }}>
        {/* Inner Donut - Categories */}
        { flag && showInnerChart && 
          <Pie
            data={categoryData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={50} // 55
            outerRadius={90} // 95
            fill="#8884d8"
            isAnimationActive={false} 
            label={renderCategoryLabel}
          // label
          >
            {categoryData.map((entry, index) => (
              <Cell key={`cell-category-${index}`} fill={CATEGORY_COLORS[index]} />
            ))}
          </Pie>
        }

        {/* Outer Donut - Countries */}
        <Pie
          data={countryData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={92} // 97
          outerRadius={132} // 137
          // label
          // label={CustomLabelWithTick}
          label={CustomLabelWithY2Tick}
          labelLine={false}
          isAnimationActive={false} 
        >
          {countryData.map((entry, index) => (
            <Cell key={`cell-country-${index}`} fill={COUNTRY_COLORS[index]} />
          ))}
        </Pie>

        <Tooltip content={<CustomTooltip />}/>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default SpendDonutChart;
